const userQueryKeys = {
  list: (args: { case_id?: number }) => ["users", "list", args],
  infiniteList: (args: { case_id?: number }) => [
    "users",
    "infinite-list",
    args,
  ],
};

export const UsersAPI = {
  queryKeys: userQueryKeys,
};
